module.exports = __webpack_public_path__ + "img/Culiacan.25c88168.svg";